import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const Clock2 = ({ fill: fillProp, style }: IconProps) => {
  const { theme } = useTheme();

  const fill = fillProp ?? theme.icon.default;

  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M17.3333 28.3327C14.1694 28.3327 11.4896 27.2348 9.29375 25.0389C7.09792 22.8431 6 20.1632 6 16.9993C6 13.8355 7.09792 11.1556 9.29375 8.95977C11.4896 6.76393 14.1694 5.66602 17.3333 5.66602C20.4972 5.66602 23.1771 6.76393 25.3729 8.95977C27.5688 11.1556 28.6667 13.8355 28.6667 16.9993C28.6667 20.1632 27.5688 22.8431 25.3729 25.0389C23.1771 27.2348 20.4972 28.3327 17.3333 28.3327ZM17.3333 26.2077C19.8597 26.2077 22.026 25.3046 23.8323 23.4983C25.6385 21.6921 26.5417 19.5257 26.5417 16.9993C26.5417 14.473 25.6385 12.3066 23.8323 10.5004C22.026 8.69414 19.8597 7.79102 17.3333 7.79102C14.8069 7.79102 12.6406 8.69414 10.8344 10.5004C9.02813 12.3066 8.125 14.473 8.125 16.9993C8.125 19.5257 9.02813 21.6921 10.8344 23.4983C12.6406 25.3046 14.8069 26.2077 17.3333 26.2077Z"
        fill={fill}
      />
      <path
        d="M21.4964 22.4682L22.7714 21.1932L18.2664 16.6598V10.9648H16.5664V17.3398L21.4964 22.4682Z"
        fill={fill}
      />
    </svg>
  );
};
